<template>
    <div>
        <!-- 广告 -->
        <div class="m-adv" v-if="isAdv">
            <div class="countDown">{{countDown}}s后关闭</div>
            <!-- 片头广告 -->
            <div class="header-adv" v-if="playerHeaderAdv">
                <a :href="headerAdvObj.addrurl">
                    <!-- 图片 -->
                    <img v-if="headerAdvObj.ad_resource == '1'" :src="headerAdvObj.matterurl" alt="">
                    <!-- 视频 -->
                    <video v-else :src="headerAdvObj.matterurl" muted autoplay></video>
                </a>
            </div>
            <!-- 片尾广告 -->
            <div class="footer-adv" v-if="playerFooterAdv">
                <a :href="footerAdvObj.addrurl">
                    <!-- 图片 -->
                    <img v-if="footerAdvObj.ad_resource == '1'" :src="footerAdvObj.matterurl" alt="">
                    <!-- 视频 -->
                    <video v-else :src="footerAdvObj.matterurl" muted autoplay></video>
                </a>
            </div>
        </div>
        <div class="m-vod" v-show="!isAdv">
            <!-- 保利 -->
            <template v-if="playerType == 'polyv'">
                <div class="polyv-content" id="player" preload="auto" ></div>
            </template>
       
            <div class="tc-player" v-show="playerType == 'tc'">
                <video id="tcPlayerRef" width="414" height="270" preload="auto" playsinline webkit-playsinline></video>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import TCPlayer from 'tcplayer.js';
import { Toast } from 'vant'
import 'tcplayer.js/dist/tcplayer.min.css';
export default {
    name: 'Mvod',
    components: {
    },
    data() {
        return {
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            sign: '',
            ts_video: '',
            appid: '',
            token: '',
            playerType: 'polyv', // polyv 保利  tc腾讯
            isAdv: false,
            headerAdvObj: {},
            footerAdvObj: {},
            playerHeaderAdv: false,
            playerFooterAdv: false,
            timer: null,
            countDown: 0,
            player: null,
            timerTips: null,
        }
    },
    computed: {
        ...mapState(['live_banner', 'userInfo', 'meeting_id']),
    },
    methods: {
        loadPlayerScript(callback, url) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script')
                myScript.setAttribute('src', this.vodPlayerJs)
                myScript.onload = callback
                document.body.appendChild(myScript)
            } else {
                callback()
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                autoplay: false,
                speed: false, //倍速播放
                vid: this.vid,
                ts: this.ts_video,
                sign:this.sign,
                playsafe: (vid, next) => {
                    this.request.get('getVideoToken', {
                        vid: vid,
                        user_name: this.userInfo.RealName,
                        user_id: this.userInfo.user_id
                    }).then((res) => {
                        next(res.data.token)
                    })
                },
            });
            this.player.on('s2j_onPlayOver', (e) => {
                if (Object.keys(this.footerAdvObj).length > 0) {
                    this.$nextTick(() => {
                        this.startAdv('footer')
                        this.player.j2s_seekVideo(0)
                    })
                }
            })
        },
        loadTcPlayer () {
            this.player = TCPlayer('tcPlayerRef', { // player-container-id 为播放器容器 ID，必须与 html 中一致
                fileID: this.vid, // 请传入需要播放的视频 fileID（必须）
                appID: this.appid, // 请传入点播账号的 appID（必须）
                //必传 psign， psign 即播放器签名，签名介绍和生成方式参见链接：https://cloud.tencent.com/document/product/266/42436
                psign: this.sign,
                licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1257143971_1/v_cube.license', // 参考准备工作部分，在视立方控制台申请 license 后可获得 licenseUrl
            });
            this.player.on('ended', () => {
                if (Object.keys(this.footerAdvObj).length > 0) {
                    this.$nextTick(() => {
                        this.startAdv('footer')
                        this.player.pause()
                    })
                }
            })
        },
        // 获取视频点播广告
        getVodAdv () {
            this.request.get('getVodAdv', { video_id: this.$route.query.video_id }).then((res) => {
                let { video_player_ad } = res.data
                // console.log(JSON.stringify(video_player_ad))
                // video_player_ad = [{"id":"153","title":"piantou","ad_desc":"","type":"1","type_id":"296407","ad_type":"1","ad_resource":"1","matterurl":"https://files.sciconf.cn/master/512/0/202501/2025011017350692714510683.png","addrurl":"","timesize":"5","skipenabled":"0","skipbutton":null,"is_display":"1","status":"1","click_num":"0","create_time":"2025-01-10 14:11:17","update_time":"2025-01-10 17:35:08"},{"id":"154","title":"pianweiguangg","ad_desc":"片尾广告","type":"1","type_id":"296407","ad_type":"2","ad_resource":"1","matterurl":"https://files.sciconf.cn/master/512/0/202501/2025011014113621461039857.jpg","addrurl":"","timesize":"5","skipenabled":"0","skipbutton":null,"is_display":"1","status":"1","click_num":"0","create_time":"2025-01-10 14:11:40","update_time":"2025-01-10 17:13:31"}]
                video_player_ad.forEach((item, index) => {
                    if (item.is_display == '1') {
                        if (item.ad_type == '1') { // 片头
                            this.headerAdvObj = item
                        } else if (item.ad_type == '2') { // 片尾
                            this.footerAdvObj = item
                        }
                    }
                });
                if (Object.keys(this.headerAdvObj).length == 0) {
                    this.getVideoParam()
                } else { // 播放广告
                    this.startAdv('header')
                }
            })
        },
        getVideoParam () {
            this.request.get('getVideoParams', {
                is_applet: 0,
                video_id: this.$route.query.video_id,
                device_type: '1'
            }).then((res) => {
                if (res.code == 2000) {
                    setTimeout(() => {
                        Toast({
                            type:'fail',
                            duration: 5000,
                            message: res.msg
                        })
                    }, 1000);
                }
                if (!res.data) {
                    window.location.href = `https://medcon.sciconf.cn/cn/reg/index/${this.meeting_id}`
                    return false
                }
                const { data } = res
                this.vid = data.vid
                this.sign = data.sign
                this.ts_video = data.ts_video
                if (data.appid) { // 腾讯
                    this.appid = data.appid
                    this.playerType = 'tc'
                    this.$nextTick(() => {
                        this.loadTcPlayer()
                    })
                } else { // 保利
                    this.playerType = 'polyv'
                    this.$nextTick(() => {
                        this.loadPlayerScript(this.loadPlayer)
                    })
                }
            }).catch((err) => {
                if (err.code == 401) {
                    console.log(err)
                    this.$emit('login', err.code_url)
                    // if (!localStorage.getItem('auth')) {
                    //     // window.location.href = `https://www.sciconf.cn/unified/login?return_url=${encodeURIComponent(window.location.href)}`
                    // }
                }
            })
        },
        startAdv (type) {
            this.isAdv = true
              if (type == 'header') {
                    this.countDown = Number(this.headerAdvObj.timesize)
                    this.playerHeaderAdv = true
                    this.timer = setInterval(() => {
                        this.countDown--
                        if (this.countDown == 0) {
                            this.playerHeaderAdv = false
                            this.isAdv = false
                            this.getVideoParam()
                            clearInterval(this.timer)
                        }
                    }, 1000);
                } else {
                    this.countDown = Number(this.footerAdvObj.timesize)
                    this.playerFooterAdv = true
                    this.timer = setInterval(() => {
                        this.countDown--
                        if (this.countDown == 0) {
                            this.playerFooterAdv = false
                            this.isAdv = false
                            clearInterval(this.timer)
                            this.player.play()
                        }
                    }, 1000);
                }
        }
    },
    mounted () {
        if (this.$route.query.video_id) {
           this.getVodAdv()
        }
    },
    beforeDestroy () {
        clearInterval(this.timer)
    }
}
</script>
<style lang="less" scoped>

@media screen and (max-width: 768px) {
    .polyv-content {
        width: 100%;
        position: absolute;
        width: 100%;
        height: 100%;
        /deep/.plv-player-container {
            position: absolute;
            left: 0;
            top: 0;
            width: 100% !important;
            height: 100% !important;
        }
    }
    .m-vod {
        position: relative;
        padding-bottom: 56.25%;
    }
}
.tips {
    width: 200px;
    height: 200px;
    position: fixed;
    left: 50%;
    top: 50%;
}
.m-adv {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    .header-adv, .footer-adv {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        video {
            width: 100%;
            height: 100%;
        }
    }
    .countDown {
        position: absolute;
        left: 10px;
        top: 10px;
        padding: 5px 20px;
        box-sizing: border-box;
        border-radius: 20px;
        background: rgba(0, 0, 0, 0.3);
        color: #ffffff;
        z-index: 6666;
    }
}
.tc-player {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    .tcplayer  {
        position: absolute;
        left: 0;
        top: 0;
        width: 100% !important;
        height: 100% !important;
    }
}
</style>